import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { SESSION_STORAGE_KEYS } from '@/lib/local-storage-keys'

export type ManagedAccountFeatureType =
  | 'One'
  | 'Pro'
  | 'Max'
  | 'Trial'
  | 'Free'
  | null

interface ManagedAccountData {
  accountId: string
  accountName: string | null
  featureType: ManagedAccountFeatureType
  shouldGenerateNfe: boolean
}

interface ManagedAccountStore {
  isManaging: boolean
  accountId: string | null
  accountName: string | null
  featureType: ManagedAccountFeatureType
  // Whether the managed account is invoiced with an NFe; false while not managing,
  // so a stale value can never keep tax data visible on the admin's own account.
  shouldGenerateNfe: boolean

  setManagedAccount: (data: ManagedAccountData) => void
  clearManagedAccount: () => void
}

export const useManagedAccountStore = create<ManagedAccountStore>()(
  // @ts-ignore - Known issue with Zustand 5.x and TypeScript strict mode with persist middleware
  persist(
    (set) => ({
      isManaging: false,
      accountId: null,
      accountName: null,
      featureType: null,
      shouldGenerateNfe: false,

      setManagedAccount: (data) => {
        set({
          isManaging: true,
          accountId: data.accountId,
          accountName: data.accountName,
          featureType: data.featureType,
          shouldGenerateNfe: data.shouldGenerateNfe,
        })
      },

      clearManagedAccount: () => {
        set({
          isManaging: false,
          accountId: null,
          accountName: null,
          featureType: null,
          shouldGenerateNfe: false,
        })
      },
    }),
    {
      name: SESSION_STORAGE_KEYS.MANAGED_ACCOUNT,
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
